<template>
  <VTable
    v-if="table.data.length"
    :table="table"
    class="manager-company-opportunity-lookup-listings"
  >
    <template #col-9="{ colData }">
      <VBtn
        v-if="colData"
        class="pitch-panel-underlined"
        flat
        :href="colData"
        target="_blank"
        rel="noopener noreferrer"
        >View</VBtn
      >
      <template v-else>-</template>
    </template>
  </VTable>
  <VFallbackText v-else>No data found</VFallbackText>
</template>

<script setup lang="ts">
  // Types
  import type { ITable } from '~/misc/v-table/types';
  import type { TManagerCompanyOpportunityLookupListing } from '~/modules/manager/types';

  // Config
  import { TABLE_HEADERS } from '~/modules/manager/company/opportunity-lookup/result/listings/config';

  // Utils
  import { formatPrice } from '~/misc/utils/number';
  import { DateTimeFormatter } from '~/misc/utils/datetime';

  // Components
  import VTable from '~/misc/v-table';
  import VBtn from '~/misc/v-btn';
  import VFallbackText from '~/misc/v-fallback-text/VFallbackText.vue';

  const props = defineProps({
    data: {
      type: Array as PropType<TManagerCompanyOpportunityLookupListing[]>,
      required: true,
    },
  });

  const table: ComputedRef<ITable> = computed<ITable>(() => ({
    headers: TABLE_HEADERS,
    data: props.data.length
      ? props.data.map((item: TManagerCompanyOpportunityLookupListing) => [
          item.address || 'Unknown',
          item.type || '-',
          item.status || '-',
          item.current_price ? formatPrice(item.current_price) : '-',
          item.original_price ? formatPrice(item.original_price) : '-',
          item.reduced_at ? DateTimeFormatter.toShortDate(item.reduced_at) : '-',
          item.underoffer_at ? DateTimeFormatter.toShortDate(item.underoffer_at) : '-',
          item.sstc_at ? DateTimeFormatter.toShortDate(item.sstc_at) : '-',
          item.listed_at ? DateTimeFormatter.toShortDate(item.listed_at) : '-',
          item.listing_url || '',
          item.agent_name || '-',
        ])
      : [],
  }));
</script>
